import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  name: Yup.string(),
  lastName: Yup.string(),
});

export default validationSchema;
